import React, { Component } from "react";
import logo from "../images/bp-logo.png";
import { ClinicSelectList } from "../components/DataSelectList";
import "./Login.css";
import "./AppConfirm.css";
import { Input, Button } from "../components/FormUI";
import {Redirect} from "react-router-dom";

import moment from 'moment';
import AppointmentService from "../api/services/AppointmentService";

const statusLabel = {
    'confirmed': 'Confirmed',
    'cancelled': 'Cancelled'
}

export default class AppConfirm extends Component{

    /*

    {
    "appointmentId": 902939,
    "start": "2017-11-26T13:00:00",
    "end": "2017-11-26T13:45:00",
    "appointmentType": "Evaluation - Bracing",
    "comment": "",
    "status": "Booked",
    "firstName": "William",
    "pedorthistName": "Jennifer Ambroise",
    "clinicInfo": {
        "clinicId": 24,
        "name": "Guelph",
        "address": "102 Wyndham Street North",
        "city": "Guelph",
        "province": "Ontario",
        "postalCode": "N1H 4E8",
        "email": "guelph@bioped.com",
        "phone": "519-821-7310",
        "fax": "519-821-5931 ",
        "website": "www.bioped.com"
    }

    */

    state = {
        buttonCaption:'Confirming...',
        isBusy: true,
        mode: window.$_GET['appstatus'],
        clinic:{}
    }
    componentDidMount(){
        let app = new AppointmentService();
        let appid = window.$_GET['appointmentId'];
        let status = statusLabel[window.$_GET['appstatus']] || window.$_GET['appstatus'];
        let secret = window.$_GET['secret'];

        if(appid && status && secret){
            app.updateStatus(appid, status, secret).then((d) => {
                console.log("Status Updated!:", d)
                this.setState({
                    buttonCaption:'Close',
                    isBusy:false,
                    name: d.firstName,
                    time: moment(d.start).format('h:mma'),
                    clinic: d.clinicInfo || {},
                    notFound: !d.firstName
                });
            })
        }else{
            this.setState({buttonCaption:'Close', isBusy:false});
        }


    }

    render(){

        if(this.state.close && !this.state.isBusy){
            window.location = 'http://bioped.com';
            return '';
        }

        if(this.state.notFound){
            return <div className="LoginView app-confirm">
                        <div className="decoration"></div>
                        <div className="content">
                            <div>
                                <div className="app-confirm-header">
                                    <img src={logo} alt="Logo" /><br />
                                    <span>Appointment Not Found.</span>
                                </div>
                                <Button className="sign-in green" caption={this.state.buttonCaption} isBusy={this.state.isBusy} onClick={()=>this.setState({close:true})} />
                            </div>
                        </div>
                        <div className="copyright">
                            &copy; Copyright BioPed Franchising Inc.All rights reserved.
                        </div>
                    </div>
        }




        switch ((window.$_GET['appstatus'] || '').toLowerCase()) {
            case 'confirmed':
                return (
                    <div className="LoginView app-confirm">
                        <div className="decoration"></div>
                        <div className="content">
                            <div>
                                <div className="app-confirm-header">
                                    <img src={logo} alt="Logo" /><br />
                                    <span>Thank you {this.state.name}, your appointment is confirmed.</span>
                                </div>
                                <div className="app-confirm-cta">
                                    <div><strong>Appointment Confirmed.</strong></div>
                                    <div>See you then!</div>
                                </div>
                                <div className='app-confirm-details'>
                                    <div className='app-confirm-time'>{this.state.time}</div>
                                    <div className='app-confirm-address'>
                                        <div><strong>{this.state.clinic.name}</strong></div>
                                        <div>{this.state.clinic.address}</div>
                                        <div>{this.state.clinic.city + ' ' + this.state.clinic.province + ' ' + this.state.clinic.postalCode}</div>
                                    </div>
                                </div>
                                <Button className="sign-in green" caption={this.state.buttonCaption} isBusy={this.state.isBusy} onClick={()=>this.setState({close:true})} />
                            </div>
                        </div>
                        <div className="copyright">
                            &copy; Copyright BioPed Franchising Inc.All rights reserved.
                        </div>
                    </div>
                );
            break;
            case 'cancelled':
                return (
                    <div className="LoginView app-confirm">
                        <div className="decoration"></div>
                        <div className="content">
                            <div>
                                <div className="app-confirm-header">
                                    <img src={logo} alt="Logo" /><br />
                                    <span>Your Appointment has been cancelled.</span>
                                </div>
                                <Button className="sign-in green" caption={this.state.buttonCaption} isBusy={this.state.isBusy} onClick={()=>this.setState({close:true})} />
                            </div>
                        </div>
                        <div className="copyright">
                            &copy; Copyright BioPed Franchising Inc.All rights reserved.
                        </div>
                    </div>
                );
            break;
        }

        return 'Nothing to see here.';


    }
}



// WEBPACK FOOTER //
// ./src/views/AppConfirm.js